import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    gender: "",
    degree: "",
    branch: null,
    profilePhotoName: "",
    timeZone: "",
  },
  isLoaded: false,
  profile: {},
};
const doctorSlice = createSlice({
  name: "doctor",
  initialState,
  reducers: {
    setProfile: (state, { payload }) => {
      state.profile = payload;
    },
    setDoctors: (state, { payload }) => {
      state.list = payload;
      state.isLoaded = true;
    },
    addDoctorToList: (state, { payload }) => {
      var createdDoctor = {
        id: payload.id,
        firstName: payload.firstName,
        lastName: payload.lastName,
        email: payload.email,
        degree: payload.degree,
        phoneNumber: payload.phoneNumber,
        gender: payload.gender,
        branch: payload.branch,
        timeZone: payload.timeZone,
      };
      // state.list.push(createdDoctor);
      state.list = [createdDoctor, ...state.list];
    },
    removeDoctorToList: (state, { payload }) => {
      state.list = state.list.filter((item) => item.id !== payload);
    },
    updateDoctorList: (state, { payload }) => {
      state.list = state.list.map((item) =>
        item.id === payload.id ? payload : item
      );
    },
    clearDoctors: (state) => {
      state.list = [];
    },
    setSelectedDoctor: (state, { payload }) => {
      state.selected = payload;
    },
    clearSelectedDoctor: (state) => {
      state.selected = {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        degree: "",
        phoneNumber: "",
        gender: "",
        branch: null,
        timeZone: "",
      };
    },
  },
});

export const {
  setDoctors,
  clearDoctors,
  updateDoctorList,
  removeDoctorToList,
  addDoctorToList,
  clearSelectedDoctor,
  setSelectedDoctor,
  setProfile,
} = doctorSlice.actions;
export default doctorSlice.reducer;
